import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import whatsappApi from '../whatsapp/whatsappApi'
import { resolveComposeComponent } from './commComposeRegistry'

const INACTIVE_MESSAGE = 'WhatsApp Automation service is not Active on Your Account'
const WA = '#25D366'

// Created By Cursor
const CommWhatsAppPanel = ({
  compact = false,
  onStatusChange,
  selectedService = null,
}) => {
  const [account, setAccount] = useState(null)
  const [wallet, setWallet] = useState(null)
  const [serviceActive, setServiceActive] = useState(null)
  const [serviceMessage, setServiceMessage] = useState(INACTIVE_MESSAGE)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    whatsappApi
      .getAccount()
      .then((res) => {
        if (res.api_status === 'OK' && res.data) {
          setServiceActive(!!res.data.service_active)
          setServiceMessage(res.data.service_message || INACTIVE_MESSAGE)
          setAccount(res.data.account || null)
          setWallet(res.data.wallet || null)
        } else {
          setServiceActive(false)
          setServiceMessage(INACTIVE_MESSAGE)
        }
      })
      .catch(() => {
        setServiceActive(false)
        setServiceMessage(INACTIVE_MESSAGE)
      })
      .finally(() => setLoading(false))
  }, [])

  const connected = account && account.connection_status === 'connected'

  if (loading) {
    return (
      <div style={{ padding: '28px 8px', textAlign: 'center', color: '#64748b', fontSize: 13 }}>
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            border: `2px solid ${WA}33`,
            borderTopColor: WA,
            margin: '0 auto 8px',
            animation: 'waSpin 0.7s linear infinite',
          }}
        />
        Checking WhatsApp…
        <style>{`@keyframes waSpin { to { transform: rotate(360deg); } }`}</style>
      </div>
    )
  }

  if (serviceActive === false) {
    return (
      <div
        style={{
          padding: '18px 14px',
          borderRadius: 10,
          border: '1px solid #fecaca',
          background: 'linear-gradient(180deg, #fef2f2, #fff)',
          textAlign: 'center',
        }}
      >
        <i className="fa fa-exclamation-triangle" style={{ fontSize: 20, color: '#dc2626' }} />
        <div style={{ fontSize: 14, fontWeight: 800, color: '#991b1b', marginTop: 8 }}>
          {serviceMessage || INACTIVE_MESSAGE}
        </div>
        <Link
          to="/AdminMain/WhatsAccountSettings"
          style={{ display: 'inline-block', marginTop: 10, fontSize: 12, fontWeight: 700 }}
        >
          Open WhatsApp Settings
        </Link>
      </div>
    )
  }

  if (!selectedService) {
    return (
      <div
        style={{
          padding: '18px 14px',
          borderRadius: 10,
          border: '1px dashed #cbd5e1',
          background: '#f8fafc',
          textAlign: 'center',
          color: '#64748b',
          fontSize: 13,
          fontWeight: 600,
        }}
      >
        Select a message service above to compose
      </div>
    )
  }

  const ComposeComponent = resolveComposeComponent(selectedService)
  const serviceKey =
    selectedService.service_code || selectedService.id || selectedService.service_name

  return (
    <div>
      {!compact && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8,
            marginBottom: 12,
          }}
        >
          <Pill ok={connected} text={connected ? 'Connected' : 'Not connected'} />
          <Pill text={account?.display_phone_number || 'No number'} />
          <Pill text={`Wallet ₹${Number(wallet?.balance || 0).toFixed(0)}`} />
        </div>
      )}

      <ComposeComponent
        key={serviceKey}
        service={selectedService}
        connected={!!connected}
        onStatusChange={onStatusChange}
      />
    </div>
  )
}

// Created By Cursor
function Pill({ text, ok }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 999,
        padding: '4px 10px',
        fontSize: 12,
        fontWeight: 700,
        color: '#334155',
      }}
    >
      {typeof ok === 'boolean' && (
        <span
          style={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: ok ? '#22c55e' : '#f59e0b',
          }}
        />
      )}
      {text}
    </span>
  )
}

export default CommWhatsAppPanel
